import { render, staticRenderFns } from "./DatavMapMain.vue?vue&type=template&id=24a35c68&scoped=true&"
import script from "./DatavMapMain.vue?vue&type=script&lang=js&"
export * from "./DatavMapMain.vue?vue&type=script&lang=js&"
import style0 from "./DatavMapMain.vue?vue&type=style&index=0&id=24a35c68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a35c68",
  null
  
)

component.options.__file = "DatavMapMain.vue"
export default component.exports